import { apiService } from '../api';
import { replacePathParams } from '@/helpers/urlHelpers';

const ENDPOINTS = {
  VIP_CONTENT_BY_WEBSITE_ID: '/vip-page/website/:websiteId',
  VIP_CONTENT_CREATE_OR_UPDATE: '/vip-page',
  VIP_PAGE_BY_ID: '/vip-page/:id',
  VIP_PAGE_PUBLISH: '/vip-page/:id/publish',
  VIP_PAGE_DEACTIVATE: '/vip-page/:id/deactivate',
  VIP_ASSETS_BY_WEBSITE_ID: '/vip-assets/:websiteId',
  VIP_ASSETS_BY_ID: '/vip-assets/:id',
};

class VipService {
  async getVipContent(websiteId) {
    try {
      return await apiService.get(
        replacePathParams(ENDPOINTS.VIP_CONTENT_BY_WEBSITE_ID, { websiteId })
      );
    } catch (error) {
      throw error;
    }
  }

  async getVipPageById(id) {
    try {
      return await apiService.get(
        replacePathParams(ENDPOINTS.VIP_PAGE_BY_ID, { id })
      );
    } catch (error) {
      throw error;
    }
  }

  async createVipPage(data) {
    try {
      return await apiService.post(
        ENDPOINTS.VIP_CONTENT_CREATE_OR_UPDATE,
        data
      );
    } catch (error) {
      throw error;
    }
  }

  async updateVipContent(id, data) {
    try {
      return await apiService.put(
        replacePathParams(ENDPOINTS.VIP_PAGE_BY_ID, { id }),
        data
      );
    } catch (error) {
      throw error;
    }
  }

  async removeVipPage(id) {
    try {
      return await apiService.delete(
        replacePathParams(ENDPOINTS.VIP_PAGE_BY_ID, { id })
      );
    } catch (error) {
      throw error;
    }
  }

  async publishVipPage(id) {
    try {
      return await apiService.patch(
        replacePathParams(ENDPOINTS.VIP_PAGE_PUBLISH, { id })
      );
    } catch (error) {
      throw error;
    }
  }

  async deactivateVipPage(id) {
    try {
      return await apiService.patch(
        replacePathParams(ENDPOINTS.VIP_PAGE_DEACTIVATE, { id })
      );
    } catch (error) {
      throw error;
    }
  }

  async getVipAssets(websiteId) {
    try {
      return await apiService.get(
        replacePathParams(ENDPOINTS.VIP_ASSETS_BY_WEBSITE_ID, { websiteId })
      );
    } catch (error) {
      throw error;
    }
  }

  async uploadVipAsset(websiteId, formData) {
    try {
      return await apiService.post(
        replacePathParams(ENDPOINTS.VIP_ASSETS_BY_WEBSITE_ID, { websiteId }),
        formData
      );
    } catch (error) {
      throw error;
    }
  }

  async deleteVipAsset(id) {
    try {
      return await apiService.delete(
        replacePathParams(ENDPOINTS.VIP_ASSETS_BY_ID, { id })
      );
    } catch (error) {
      throw error;
    }
  }
}

export const vipService = new VipService();
